import client from '../api/client.js'

export const fetchPublicLotteryResultRequest = async (lotteryRef) => {
  const response = await client.get(`/public/lotteries/${lotteryRef}/result`)
  return response?.data
}

export const lookupPublicTicketRequest = async (reference) => {
  const response = await client.get('/public/tickets/lookup', {
    params: {
      reference,
    },
  })
  return response?.data
}

